export default "__VITE_ASSET__DJkERnVK__"